import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chartTitle: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.chart-title',
		defaultMessage: 'All deployment environment types',
		description:
			'Title of a chart that shows deployment frequencies for all deployment environment types.',
	},
	titleHelpTooltip: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.title-help-tooltip',
		defaultMessage:
			'Compare your deployment frequency for all environment types. To avoid risky deployments, try to deploy to production more often, or equally to other environments.',
		description:
			'The message that is displayed when the mouse is hovered on the question mark beside the non-production deployment frequency line chart title.',
	},
	noMappedWarningTitle: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.no-mapped-warning-title',
		defaultMessage: 'No mapped deployment data',
		description:
			'The title of the banner that is shown when there is unmapped deployment data is detected without production deployment at all.',
	},
	noMappedWarningDescription: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.no-mapped-warning-description',
		defaultMessage:
			'To make full use of this report, configure your deployment tool to map your deployments to environment types.',
		description:
			'The description of the banner that is shown when there is unmapped deployment data is detected without production deployment at all. By showing this, we want to encourage customer to setup deployment information correctly to generate more meaningful report.',
	},
	nonProdWarningTitle: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.non-prod-warning-title',
		defaultMessage: 'No production deployment data',
		description:
			'The title of the banner that is shown when there is unmapped deployment data is detected without production deployment at all.',
	},
	nonProdWarningDescription: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.non-prod-warning-description',
		defaultMessage:
			'To make full use of this report, configure your deployment tool to map your production deployments to the production environment.',
		description:
			'The description of the banner that is shown when there is unmapped deployment data is detected without production deployment at all. By showing this, we want to encourage customer to setup deployment information correctly to generate more meaningful report.',
	},
	dropDownButtonDescription: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.drop-down-button-description',
		defaultMessage: 'Show all deployment environment types',
		description:
			'Title of a button that shows deployment frequencies for all deployment environment types.',
	},
	dropDownButtonOpenDescription: {
		id: 'software-deployment-frequency-report.line-chart-by-environment.drop-down-button-open-description',
		defaultMessage: 'Hide all deployment environment types',
		description:
			'Title of a button that hides deployment frequencies for all deployment environment types.',
	},
});
